// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Changes here may need to be reflected in CardFront.less */
.FOAGIKgFwAdtpQ {
  display: flex;
  flex-flow: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.FOAGIKgFwAdtpQ div[role='presentation'] {
  display: flex;
  position: relative;
}
.FOAGIKgFwAdtpQ .yRwdodao8tIG_y {
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  margin: 2px 6px 0 0;
  padding: 0;
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .QKpfFWf8HvDnZb {
  display: flex;
  position: relative;
  z-index: 1;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
@media (prefers-reduced-motion: no-preference) {
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .QKpfFWf8HvDnZb.PtC3F0T8lzrD1P {
    animation: tEIweer6GlU_qr 0.3s ease-in;
  }
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .QKpfFWf8HvDnZb span svg {
  opacity: 1;
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .ZCTd46AUqdDoSz span svg {
  height: 10px;
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .ZCTd46AUqdDoSz:active svg circle {
  stroke: currentColor;
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln {
  position: absolute;
  top: 0;
  right: 2px;
  bottom: 2px;
  left: 0;
  pointer-events: none;
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 1.5px;
  transform-origin: center;
  opacity: 0;
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(1) {
  --rotation: 0deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(2) {
  --rotation: 45deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(3) {
  --rotation: 90deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(4) {
  --rotation: 135deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(5) {
  --rotation: 180deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(6) {
  --rotation: 225deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(7) {
  --rotation: 270deg;
  transform: rotate(var(--rotation)) translate(11px);
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(8) {
  --rotation: 315deg;
  transform: rotate(var(--rotation)) translate(11px);
}
@media (prefers-reduced-motion: no-preference) {
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(1).GOQX_WJPjECQWX,
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(3).GOQX_WJPjECQWX,
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(5).GOQX_WJPjECQWX,
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(7).GOQX_WJPjECQWX {
    animation: RllSxgrUR7Gaxi 0.8s ease-in-out;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(1).wZA5mQeAAo4fFZ,
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(3).wZA5mQeAAo4fFZ,
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(5).wZA5mQeAAo4fFZ,
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(7).wZA5mQeAAo4fFZ {
    animation: h3BP8eWd_AkVjh 0.8s ease-in-out;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(2).GOQX_WJPjECQWX,
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(4).GOQX_WJPjECQWX,
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(6).GOQX_WJPjECQWX,
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(8).GOQX_WJPjECQWX {
    animation: RdNgShzH0Mn0dR 0.8s ease-in-out;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(2).wZA5mQeAAo4fFZ,
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(4).wZA5mQeAAo4fFZ,
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(6).wZA5mQeAAo4fFZ,
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H .Mu3z2cwV9SURln .z2plkrvtuMatdM:nth-child(8).wZA5mQeAAo4fFZ {
    animation: hdaUIBKebxr_OC 0.8s ease-in-out;
  }
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H .hAkW3qigJbr3l3 {
  bottom: -2px;
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H.wqMWMRMJSBwjjn {
  transition: opacity 0.3s ease-in;
  opacity: 0;
}
@media (prefers-reduced-motion: reduce) {
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H.wqMWMRMJSBwjjn {
    transition: none;
    opacity: 1;
  }
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H.wqMWMRMJSBwjjn:focus-visible {
  transition: opacity 0.3s ease-in;
  opacity: 1;
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H:disabled {
  cursor: pointer;
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H:active:not(:disabled) {
  transform: scale(0.9);
  transition: all 0.1s ease-in;
  opacity: 0.8;
}
@media (prefers-reduced-motion: reduce) {
  .FOAGIKgFwAdtpQ .ebipx1HCdlU24H:active:not(:disabled) {
    transform: none;
    transition: none;
    opacity: 1;
  }
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H:hover:not(:disabled) {
  background: transparent;
}
.FOAGIKgFwAdtpQ .ebipx1HCdlU24H:hover:not(:disabled) span svg {
  opacity: 0.9;
}
.FOAGIKgFwAdtpQ .q9t4eodOsgo_gm {
  width: 100%;
}
@media (prefers-reduced-motion: reduce) {
  .FOAGIKgFwAdtpQ .q9t4eodOsgo_gm {
    width: calc(100% - 20px);
  }
}
.FOAGIKgFwAdtpQ .q9t4eodOsgo_gm.BZe5qUJCSCM4y3 {
  width: calc(100% - 20px);
  color: var(--ds-text-subtlest, #626f86);
}
.FOAGIKgFwAdtpQ .q9t4eodOsgo_gm.BZe5qUJCSCM4y3 [data-smart-element='Title'] {
  color: var(--ds-text-subtlest, #626f86);
}
.FOAGIKgFwAdtpQ .q9t4eodOsgo_gm.XX0fWMvGDtUY5r {
  width: 100%;
  transform: translateX(-20px);
  transition: all 0.3s ease-in;
}
@media (prefers-reduced-motion: reduce) {
  .FOAGIKgFwAdtpQ .q9t4eodOsgo_gm.XX0fWMvGDtUY5r {
    width: calc(100% - 20px);
    transform: translateX(0px);
    transition: none;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .FOAGIKgFwAdtpQ:hover .ebipx1HCdlU24H.wqMWMRMJSBwjjn,
  .FOAGIKgFwAdtpQ:focus-within .ebipx1HCdlU24H.wqMWMRMJSBwjjn {
    transition: opacity 0.3s ease-in;
    opacity: 1;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .FOAGIKgFwAdtpQ:hover .q9t4eodOsgo_gm.XX0fWMvGDtUY5r,
  .FOAGIKgFwAdtpQ:focus-within .q9t4eodOsgo_gm.XX0fWMvGDtUY5r {
    width: calc(100% - 20px);
    transform: translateX(0px);
    transition: transform 0.3s ease-in;
  }
}
[data-smart-block]:has(.FOAGIKgFwAdtpQ) {
  overflow: visible;
}
@keyframes tEIweer6GlU_qr {
  0% {
    transform: rotate(-15deg);
    opacity: 0;
  }
  50% {
    transform: rotate(15deg);
    opacity: 1;
  }
  100% {
    transform: rotate(0deg);
    opacity: 1;
  }
}
@keyframes RllSxgrUR7Gaxi {
  0% {
    transform: rotate(var(--rotation)) translate(11px) scaleX(1);
    opacity: 0;
  }
  25% {
    transform: rotate(var(--rotation)) translate(12px) scaleX(2);
    opacity: 1;
  }
  75% {
    transform: rotate(var(--rotation)) translate(13px) scaleX(1.5);
    opacity: 0.5;
  }
  100% {
    transform: rotate(var(--rotation)) translate(13px) scaleX(1);
    opacity: 0;
  }
}
@keyframes RdNgShzH0Mn0dR {
  0% {
    transform: rotate(var(--rotation)) translate(11px) scaleX(1);
    opacity: 0;
  }
  25% {
    transform: rotate(var(--rotation)) translate(12px) scaleX(1.5);
    opacity: 0.5;
  }
  50% {
    transform: rotate(var(--rotation)) translate(12px) scaleX(1.5);
    opacity: 1;
  }
  75% {
    transform: rotate(var(--rotation)) translate(13px) scaleX(1);
    opacity: 0.05;
  }
  100% {
    transform: rotate(var(--rotation)) translate(13px) scaleX(1);
    opacity: 0;
  }
}
@keyframes h3BP8eWd_AkVjh {
  0% {
    transform: rotate(var(--rotation)) translate(7px) scaleX(1);
    opacity: 0;
  }
  25% {
    transform: rotate(var(--rotation)) translate(8px) scaleX(2);
    opacity: 1;
  }
  75% {
    transform: rotate(var(--rotation)) translate(8px) scaleX(1.5);
    opacity: 0.5;
  }
  100% {
    transform: rotate(var(--rotation)) translate(9px) scaleX(1);
    opacity: 0;
  }
}
@keyframes hdaUIBKebxr_OC {
  0% {
    transform: rotate(var(--rotation)) translate(7px) scaleX(1);
    opacity: 0;
  }
  25% {
    transform: rotate(var(--rotation)) translate(8px) scaleX(1.5);
    opacity: 0.5;
  }
  50% {
    transform: rotate(var(--rotation)) translate(8px) scaleX(1.5);
    opacity: 1;
  }
  75% {
    transform: rotate(var(--rotation)) translate(9px) scaleX(1);
    opacity: 0.05;
  }
  100% {
    transform: rotate(var(--rotation)) translate(13px) scaleX(1);
    opacity: 0;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardDoneState": `FOAGIKgFwAdtpQ`,
	"animationContainer": `yRwdodao8tIG_y`,
	"checkmarkButton": `ebipx1HCdlU24H`,
	"iconContainer": `QKpfFWf8HvDnZb`,
	"buttonRotatingAnimation": `PtC3F0T8lzrD1P`,
	"rotateButton": `tEIweer6GlU_qr`,
	"iconContainerSmall": `ZCTd46AUqdDoSz`,
	"linesContainer": `Mu3z2cwV9SURln`,
	"line": `z2plkrvtuMatdM`,
	"lineAnimation": `GOQX_WJPjECQWX`,
	"orthogonalLineAnimation": `RllSxgrUR7Gaxi`,
	"lineAnimationSmall": `wZA5mQeAAo4fFZ`,
	"orthogonalLineAnimationSmall": `h3BP8eWd_AkVjh`,
	"diagonalLineAnimation": `RdNgShzH0Mn0dR`,
	"diagonalLineAnimationSmall": `hdaUIBKebxr_OC`,
	"linesContainerSmall": `hAkW3qigJbr3l3`,
	"buttonAnimation": `wqMWMRMJSBwjjn`,
	"cardTitle": `q9t4eodOsgo_gm`,
	"isComplete": `BZe5qUJCSCM4y3`,
	"cardTitleAnimation": `XX0fWMvGDtUY5r`
};
export default ___CSS_LOADER_EXPORT___;
